import * as d3 from 'd3-selection'

export default (selection, config) => {
  selection.each(function (d, i) {
    let container = d3.select(this)
      , gapTop = d.bottom
      , gapSize = d.dimensions.padding // This is the padding between series, calculated from the padScale in index.js
      , verticalPaddingPercent = 0.3
      , horizontalPaddingPercent = 0.4
      , fontSizePercentOfHeight = 0.45
      , group = container.selectAll('g.percentage')
                         .data(d => {
                           return i > 0 && config.percentages && typeof d.rawPercent !== 'undefined' ? [d] : []
                         })

    group.exit().remove()

    group = group.enter()
                 .append('g')
                 .attr('class', 'percentage')
                 .merge(group)

    // shape within the group
    let backdrop = group.selectAll('rect.backdrop')
                        .data(d => [d])
    backdrop.exit().remove()
    backdrop = backdrop.enter()
                       .append('rect')
                       .attr('class', 'backdrop')
                       .merge(backdrop)

    // text within the group
    let verticalPadding = gapSize * verticalPaddingPercent
      , height = gapSize + (verticalPadding * 2)
      , percent = group.selectAll('g.text-group-percent')
                       .data(d => [d])
                       .join('g')
                       .attr('class', 'text-group-percent')
                       .attr('transform', d => `translate(${d.dimensions.center}, ${d.bottom + (d.nextTop - d.bottom) / 2})`)
                       .selectAll('text.percent')
                       .data(d => [d])

    percent.exit().remove()

    percent = percent.enter()
                     .append('text')
                     .attr('class', `percent`)
                     .merge(percent)
                     .attr('font-size', height * fontSizePercentOfHeight)

    percent.text(d => {
             return config.remainingPercentageFormatter(d.rawPercent)
           })
           .raise()

    let percentWidth = 0

    if (percent.node()) {
      let width = percent.node().getBBox().width
      percentWidth = width + (width * horizontalPaddingPercent)
    }

    backdrop.attr('x', d.dimensions.center - percentWidth / 2)
            .attr('y', gapTop - verticalPadding)
            .attr('height', height)
            .attr('width', percentWidth)
            .attr('rx', height/2)
  })
}
